import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Guid, isNotNil, Nillable } from '@web/utils';
import {
  DateComponent,
  DetailsViewComponent,
  NoDataComponent,
} from '@web/shared/ui';
import { WarehouseReleaseStatus } from '../../enums/warehouse-release-status';
import { WarehouseReleaseStatusComponent } from '../warehouse-release-status/warehouse-release-status.component';

@Component({
  selector: 'app-warehouse-release-details-attributes',
  imports: [
    DateComponent,
    DetailsViewComponent,
    NoDataComponent,
    WarehouseReleaseStatusComponent,
  ],
  templateUrl: './warehouse-release-details-attributes.component.html',
  styleUrl: './warehouse-release-details-attributes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseReleaseDetailsAttributesComponent {
  public readonly id = input.required<Guid>();
  public readonly releasedAt = input.required<Date>();
  public readonly createdAt = input.required<Date>();
  public readonly approvedAt = input<Nillable<Date>>();
  public readonly number = input.required<string>();
  public readonly status = input.required<WarehouseReleaseStatus>();
  public readonly comment = input<Nillable<string>>();

  protected readonly isNotNil = isNotNil;
}
